'use client';

import { c as _c } from "react/compiler-runtime";
import { Plus } from 'lucide-react';
import { BetterTooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
const SIZE_CLASS = {
  sm: 'size-5'
} as const;
const ICON_SIZE_CLASS = {
  sm: 'size-2.5'
} as const;

/** What the mark says, and what the tray's row says beside it. */
export const NO_REVIEWER_LABEL = 'No reviewer yet';

/**
 * An empty dashed avatar with a plus: nobody reviews the pull request yet. The desktop tray draws
 * it beside a row's status; the inbox draws it where reviewers' avatars would be. With a `label`
 * it reads as an image with a tooltip; without one it sits beside text that says the same.
 */
export function NoReviewerMark(t0) {
  const $ = _c(13);
  const {
    size,
    label
  } = t0;
  const t1 = label ? "img" : undefined;
  const t2 = label ? undefined : true;
  const t3 = SIZE_CLASS[size];
  let t4;
  if ($[0] !== t3) {
    t4 = cn("flex shrink-0 items-center justify-center rounded-full border border-dashed border-muted-foreground/60 text-muted-foreground", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = ICON_SIZE_CLASS[size];
  let t6;
  if ($[2] !== t5) {
    t6 = <Plus className={t5} />;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== label || $[5] !== t1 || $[6] !== t2 || $[7] !== t4 || $[8] !== t6) {
    t7 = <span role={t1} aria-label={label} aria-hidden={t2} className={t4} data-testid="no-reviewer-mark">{t6}</span>;
    $[4] = label;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const mark = t7;
  let t8;
  if ($[10] !== label || $[11] !== mark) {
    t8 = label ? <BetterTooltip content={label}>{mark}</BetterTooltip> : mark;
    $[10] = label;
    $[11] = mark;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}